import {
    useAnimatedScrollHandler,
    useSharedValue,
} from 'react-native-reanimated';

function useAnimatedHeader() {
    const pageScrollPosition = useSharedValue(0);
    const onScroll = useAnimatedScrollHandler((event) => {
        pageScrollPosition.value =
            event.contentOffset.y >= 0 ? event.contentOffset.y : 0;
    });

    return { pageScrollPosition, onScroll };
}

export default useAnimatedHeader;
